import { Component, OnInit } from '@angular/core';
import { UserService } from './core/services/user.service';
import { User } from './shared/models/user';
import { LoadingService } from '@core/services/loading.service';
import { CommonService } from '@core/services/common.service';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { BaseComponent } from '@base/base.component';
import { Router } from '@angular/router';
import { LocaleService } from '@core/services/locale.service';
import { MaintenanceService } from '@core/services/maintenance.service';
import { ModalService } from '@core/services/modal.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss', 'shared/shared-styles.scss'],
    standalone: false
})
export class AppComponent extends BaseComponent implements OnInit {
    
  constructor(
    // Super
    public router: Router,
    public commonService: CommonService,
    public userService: UserService,
    public localeService: LocaleService,
    public maintenanceService: MaintenanceService,

    // Other Components
    public loadingService: LoadingService,
    public modalService: ModalService,
    private cookieService: CookieService,
  ) {
    super(router, commonService, userService, localeService, maintenanceService);
  }

  ngOnInit(): void {
    this.userService.getLoggedUser().subscribe((user: User) => {
      this.setInboxCookie(user);
      this.showAlertAgentSource(user);
    });
  }

  private showAlertAgentSource(user: User) {
    if (user.role == 1 && user.agentSource == 1) {
      this.loadingService.isLoading$.subscribe(x => {
        if (!x)
          this.commonService.showAlertAgentSource();
      });
    }
  }

  private setInboxCookie(user: User) {
    if (user.role !== 1) {
      return;
    }

    let LL_INBOX = {
      LL_INBOX: null,
      timestamp: (new Date(user.lastLogin)).getTime()
    };

    // overenie cookie v ramci 1 login session
    if (this.cookieService.hasKey(this.commonService.cookieNameInbox)) {
      let cookieInbox = this.cookieService.getObject(this.commonService.cookieNameInbox);
      let userLastLogin = (new Date(user.lastLogin)).getTime();

      // ak last login je vacsi ako posledny ulozeni timestamp
      if (userLastLogin > cookieInbox['timestamp']) {
        LL_INBOX.timestamp = userLastLogin;
        this.cookieService.putObject(this.commonService.cookieNameInbox, LL_INBOX, this.commonService.cookieSettings as CookieOptions);
      }
    } else {
      this.cookieService.putObject(this.commonService.cookieNameInbox, LL_INBOX, this.commonService.cookieSettings as CookieOptions);
    }

  }
}
